import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";

export default function FormInputnumber(props) {
  const {
    className,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true },
    data: {
      uiClassName,
      name,
      maxFractionDigits = 20,
      max = null,
      min = null,
      placeholder = "",
      disabled = false,
      saveFun = () => {},
    },
  } = props;

  const onChange = (type, e, field) => {
    let value = e.value;
    if (type === "blur") {
      value =
        e.target.value === ""
          ? null
          : Number(e.target.value.replaceAll(",", ""));
    }

    field.onChange(value);

    if (isSubmitted) {
      trigger();
    } else {
      trigger(name);
    }
  };

  return (
    <>
      <Controller
        key={name}
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <div
            className={classNames(
              "flex align-items-center flex-auto",
              className
            )}
          >
            <InputNumber
              id={field.name}
              className={classNames(
                { "p-invalid": fieldState.invalid },
                "w-full",
                uiClassName
              )}
              {...field}
              value={field.value ? field.value : null}
              mode="decimal"
              maxFractionDigits={maxFractionDigits}
              max={max}
              min={min}
              placeholder={placeholder}
              onChange={(e) => onChange("change", e, field)}
              onBlur={saveFun}
              disabled={!isEdit || disabled}
            />
          </div>
        )}
      />
    </>
  );
}
